<template>
  <div class="group-setup">
    <v-progress-linear indeterminate color="orange" v-if="loading"></v-progress-linear>
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <v-card class="pa-5">
      <v-card-title dark>
        <h3 class="ma-2">Board Meeting</h3>
      </v-card-title>
      <v-divider></v-divider>
      <v-form>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-text-field outlined dense v-model="form.venue" label="Venue*" required></v-text-field>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <DatePicker :lable="'Date*'" v-model="form.date" :setectVale="form.date" @changeInput="form.date = $event">
            </DatePicker>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-text-field outlined dense v-model="form.no_of_board_members" label="No of Board Members*"
              required></v-text-field>
          </v-col>
          <!-- <v-col cols="6" md="6" sm="12">
            <v-text-field outlined dense v-model="form.no_of_attendance" label="No of Outside Cabinet Officers*"
              required></v-text-field>
          </v-col> -->
        </v-row>
        <!-- <v-row>
          <v-col cols="12" md="12" sm="12">
            <v-file-input outlined dense filled v-model="form.treasure_report" prepend-icon="mdi-paperclip"
              label="Please Upload Treasure Report"></v-file-input>
          </v-col>
        </v-row> -->
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-file-input outlined dense filled v-model="form.document1" prepend-icon="mdi-paperclip"
              label="Please upload photo 01"></v-file-input>
            <small>Max Size 2Mb </small>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <v-file-input outlined dense filled v-model="form.document2" prepend-icon="mdi-paperclip"
              label="Please upload photo 02"></v-file-input>
            <small>Max Size 2Mb </small>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-file-input outlined dense filled v-model="form.document3" prepend-icon="mdi-paperclip"
              label="Please upload attendance sheet"></v-file-input>
            <small>Max Size 2Mb </small>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <v-file-input outlined dense filled v-model="form.document4" prepend-icon="mdi-paperclip"
              label="Please upload agenda"></v-file-input>
            <small>Max Size 2Mb </small>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12" sm="12">
            <v-label>Select Attended members</v-label>
            <AutocompleteAvatar @changeData="changeMembers($event)" :storeLink="'member/getClubMembersBySearch'"
              :setectVale="form.members" :itemText="'name'"></AutocompleteAvatar>
          </v-col>
        </v-row>
      </v-form>
      <v-divider></v-divider>
      <v-card-actions>
        <v-row>
          <v-col cols="12" md="9" xs="6"></v-col>
          <v-col cols="12" md="3" xs="6">
            <v-btn large color="green" depressed :disabled="loading || !form.venue" block @click="submit()">Submit to
              Review</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
    <Snackbars :text="successMsg" :snackbar="snackbar" :color="'success'" @classSnackbar="closeSnackbar" />
  </div>
</template>

<script>
import DatePicker from "@/components/shared/DatePicker";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import Alert from "@/components/shared/Alert";
import Snackbars from "@/components/shared/Snackbars";
import { ActivityService } from "../../../services/activity-service.js";
import { checkError } from "@/config/errors.js";
import AutocompleteAvatar from "@/components/shared/AutocompleteAvatar";

export default {
  name: "groupSetUpFrom",

  components: { Alert, Snackbars, DatePicker, AutocompleteAvatar },

  data: () => ({
    loading: false,
    errors: null,
    snackbar: false,
    successMsg: "",
    form: {
      venue: "",
      date: null,
      no_of_board_members: "",
      no_of_attendance: "",
      document1: null,
      document2: null,
      document3: null,
      document4: null,
      treasure_report: null,
      members: []
    },
    url: 'board_meeting',
  }),

  mounted() { },

  computed: {
    ...mapGetters({
      member: "profile",
    }),
  },

  methods: {
    submit() {
      this.errors = null;
      this.loading = true;
      this.snackbar = false;
      let fd = new FormData();
      fd.append("document1", this.form.document1);
      fd.append("document2", this.form.document2);
      fd.append("document3", this.form.document3);
      fd.append("document4", this.form.document4);
      fd.append("treasure_report", this.form.treasure_report);
      fd.append(
        "venue",
        this.form.venue
      );
      fd.append(
        "no_of_board_members",
        this.form.no_of_board_members
      );
      fd.append(
        "no_of_attendance",
        this.form.no_of_attendance
      );
      fd.append(
        "date",
        this.form.date
      );
      fd.append("month", this.$route.params.month);
      fd.append("key", "BOARD_MEETING");

      this.form.members.forEach((member, key) => {
        fd.append("members[" + key + "]", member);
      });

      let data = fd;
      ActivityService.submitActivity(this.url, data)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.$router.push("/activities/monthly");
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    changeMembers(value) {
      this.form.members = value;
    },

    onDismissed() {
      this.errors = null;
    },
    closeSnackbar() {
      this.snackbar = false;
    },
    reset() {
      this.form.name = "";
    },
  },
};
</script>
